<template>
  <div>
    <head-Back title="下载好运吧应用"></head-Back>
    <div v-if="!iosflag" class="arreement">
      <h3>下载说明</h3>
      <p class="desc">请按如下方式下载好运吧的各种应用：</p>

      <p class="title_small">一、目前共有这些聊天App</p>
      <p class="desc">
        《计算器》应用<br/>
        《天下事》应用<br/>
        《学习乐》安卓应用和《单词乐》苹果应用<br/>
      </p>
      <p class="title_small">二、下载地址和方法如下：</p>
        <textarea class="urlHrefStyle" >http://www.haoyunba.com</textarea><br/>
        <br/>
      <p class="desc">
        &nbsp;&nbsp;点击该按钮<button class="urlCopyBtnStyle" @click="onCopyUrl">复制链接</button>可自动复制下载地址，然后在手机浏览器中粘贴地址后，可直接打开页面操作：
        <br/>
        <br/>
        &nbsp;&nbsp;如果复制链接失败，请在手机浏览器中直接输入上述网址，打开网页按页面提示操作下载<br/>
     </p> 
      
    </div>
    
  </div>
</template>
<script>
import headBack from "../common/head-back-no-refresh";
import store from "@/store";
//toast组件
import tips from "@/estoast";

export default {
  name: "app",
  data() {
    return {
      msg: "隐私协议",
      iosflag: true
    };
    
  },

  mounted() {
    this.$point.init(new Date());
    store.dispatch("hideLoading");
      if (ua.indexOf("T00991") > -1) {
      this.iosflag = true;
    } else {
      this.iosflag = false;
    } 
  },
  methods: {
    onCopyUrl:function(){
       // 动态创建textarea标签
            const textarea = document.createElement('textarea');
            // 将该textarea设为readonly防止ios下自动唤起键盘，同时将textarea移出可视区域
            textarea.readOnly = 'readonly';
            textarea.style.position = 'absolute';
            textarea.style.left = '-9999px';
            // 将要copy的值赋值给textarea标签的value属性
            textarea.value = 'http://www.haoyunba.com';
            // 将textarea插入到body中
            document.body.appendChild(textarea);
            // 选中值
            textarea.select();
            // 将选中的值复制并赋值给result
            const result = document.execCommand('Copy');
            if (result) {
                tips.toast('复制成功！');
            }
            document.body.removeChild(textarea);
    }
  },
  created() {
    var ua = navigator.userAgent;
    console.log(ua.indexOf("T00991")+"0000")
    if (ua.indexOf("T00991") > -1) {
      this.iosflag = true;
    } else {
      this.iosflag = false;
    }
  },
  components: {
    headBack
  }
};
</script>
<style  scoped>
#app {
  width: 750px;
  height: 1334px;
}

.arreement {
  padding: 32px 58px 80px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(48, 48, 48, 1);
  line-height: 40px;
}

.arreement h3 {
  width: 610px;
  height: 50px;
  font-size: 36px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 600;
  color: rgba(48, 48, 48, 1);
  line-height: 50px;
}
.arreement p {
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(48, 48, 48, 1);
  line-height: 40px;
  text-align: left;
}
.arreement .arreement .title {
  text-align: left;
  padding-bottom: 30px;
  font-weight: bold;
  font-size: 32px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 500;
  color: rgba(48, 48, 48, 1);
  line-height: 44px;
}
.arreement .title_small {
  padding-top: 20px;
  line-height: 26px;
}

.arreement span {
  color: red;
  text-decoration: underline red;
}

.arreement .bold {
  font-weight: bold;
}
.arreement .text_line {
  text-decoration: underline;
}
.desc-com{
  text-align: center;
}
.urlHrefStyle{
  font-weight:bold;
  color: rgb(0, 81, 255);
  font-size: 40px;
  outline: none;
  background: transparent; 
  border-style: none;
  text-align: left;

}
.urlCopyBtnStyle {
    background-color: #4CAF50;
    border: none;
    color: white;
    padding: 15px 15px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 40px;
    margin: 4px 2px;
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/page/downappTip.vue